import { FieldInstanceValue, GroupInstance } from "@com.mgmtp.a12.kernel/kernel-md-facade";

/**
 * Checks if the data is of type GroupInstance
 * @param data
 */
export function isGroupInstanceArray(
	data: GroupInstance | GroupInstance[] | FieldInstanceValue | undefined
): data is GroupInstance[] {
	return Array.isArray(data) && !(data[0] instanceof Date);
}

export function isReadonlyGroupInstanceArray(
	data: Readonly<GroupInstance> | readonly GroupInstance[] | FieldInstanceValue | undefined
): data is readonly GroupInstance[] {
	return Array.isArray(data) && !(data[0] instanceof Date);
}

export function isFieldInstanceValue(
	data: GroupInstance | GroupInstance[] | FieldInstanceValue | undefined
): data is FieldInstanceValue {
	return (
		typeof data === "string" ||
		typeof data === "number" ||
		typeof data === "boolean" ||
		data instanceof Date ||
		(Array.isArray(data) && data[0] instanceof Date) ||
		data === null
	);
}

export function isGroupInstance(data: unknown): data is Record<string, GroupInstance> {
	return (
		typeof data !== "undefined" &&
		!Array.isArray(data) &&
		!(
			typeof data === "string" ||
			typeof data === "number" ||
			typeof data === "boolean" ||
			data instanceof Date ||
			data === null
		)
	);
}

export function isReadonlyGroupInstance(
	data: Readonly<GroupInstance> | readonly GroupInstance[] | FieldInstanceValue | undefined
): data is Readonly<GroupInstance> {
	return (
		typeof data !== "undefined" &&
		!Array.isArray(data) &&
		!(
			typeof data === "string" ||
			typeof data === "number" ||
			typeof data === "boolean" ||
			data instanceof Date ||
			data === null
		)
	);
}

export function isStringArray(
	data: (string | number | boolean | Date | Date[] | Readonly<GroupInstance>)[]
): data is string[] {
	let hasOnlyStrings = true;
	data.forEach(entry => {
		if (typeof entry !== "string") {
			hasOnlyStrings = false;
		}
	});
	return hasOnlyStrings;
}

export function isString(data: GroupInstance | FieldInstanceValue | GroupInstance[] | undefined): data is string {
	return typeof data === "string";
}
